import React, { useEffect, useState } from "react";
import "./CberrySplashScreen.css";
import { ReactComponent as CberrySplashLogo } from './assets/cberry-splash-logo.svg';

export default function CberrySplashScreen({ onDone, duration = 1800, fadeDuration = 500 }) {
  const [fading, setFading] = useState(false);

  useEffect(() => {
    const fadeTimer = setTimeout(() => setFading(true), duration);
    const doneTimer = setTimeout(() => onDone && onDone(), duration + fadeDuration);
    return () => {
      clearTimeout(fadeTimer);
      clearTimeout(doneTimer);
    };
  }, [onDone, duration, fadeDuration]);

  return (
    <div className={`splash-overlay ${fading ? "fade-out" : ""}`}>
      <div className="splash-logo">
        <CberrySplashLogo className="splash-svg-logo" aria-hidden="true" />
      </div>
      <div className="splash-text">
        <div className="splash-brand">cBerry</div>
        <div className="splash-tagline">smart power for mobile life</div>
      </div>
    </div>
  );
}
